import { useMutation } from "@apollo/client";
import { Button, Container, Text, Textarea } from "@chakra-ui/react";
import { useState } from "react";
import { connectModal, InjectedProps } from "redux-modal";
import { api } from "src/api";
import { Modal } from "src/components/Modal";
import { useMyToast } from "src/hooks";
import { useTheme } from "src/hooks/useTheme";

type Props = InjectedProps & {
  startingFeedback?: string;
  hiddenDescription?: string;
  customTitle?: string;
  customBody?: string;
};

function _FeedbackModal({
  handleHide,
  show: isVisible,
  hiddenDescription,
  startingFeedback,
  customTitle,
  customBody,
}: Props) {
  const [feedback, setFeedback] = useState(startingFeedback || "");
  const [submitFeedback, { loading }] = useMutation(api.contact.feedback);
  const toast = useMyToast();
  const theme = useTheme();

  const _onSubmit = async function () {
    if (!feedback)
      return toast.show({
        message: "Please fill out all the form fields.",
        status: "error",
      });

    try {
      await submitFeedback({
        variables: {
          feedback: `${feedback}\n\nOther: ${hiddenDescription || "-"}\nURL: ${
            window.location.href
          }\nSource: website 🌐`,
        },
      });

      toast.show({
        message: "Thank you for your feedback",
        status: "success",
      });
    } catch (err) {
      toast.show({
        message: (err as Error).message || "An error occurred.",
        status: "error",
      });
    }

    handleHide();
  };

  return (
    <Modal
      title={customTitle || "Leave Feedback"}
      isVisible={isVisible}
      handleHide={handleHide}
      Footer={
        <Button
          width="100%"
          variant="primary"
          isLoading={loading}
          onClick={_onSubmit}
        >
          Submit
        </Button>
      }
    >
      <Container padding="0px" marginTop="0px !important">
        <Text style={{ color: theme.text }} fontSize="md" fontWeight="500">
          {customBody ||
            "We work extremely hard to make Awaken a great experience, but we know we aren't perfect. So tell us how we can improve. Please be kind, an actual person will read this."}
        </Text>
        <br />
        <br />
        <Textarea
          value={feedback}
          noOfLines={12}
          height={300}
          style={{
            color: theme.header,
          }}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Type here..."
        />
      </Container>
    </Modal>
  );
}

export const FeedbackModal = connectModal({
  name: "FeedbackModal",
})(_FeedbackModal);
